import { TCartItem } from '@/entities/cart'

export const cartInfoGenerator = (cartItems: TCartItem[]) =>
	cartItems.map(item => ({
		name: item.TITLE,
		count: item.QUANTITY,
		price: item.PRICE.VALUE,
		kod: item.KOD
	}))
